export default "/_next/static/images/5-bad30d588c573bd237f4b14b93347a63.png";